<template>
    <div>
        <v-data-table :headers="users.headers" :items="users.values">
            <template #item.actions="{ item }">
                <div>
                        <v-select
                                class="mb-n2 mt-2"
                                :label="$t('chargeLevelLabel')"
                                return-object
                                v-model="item.extraCharge"
                                :items="prices"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                @change="setPricingToUser(item)"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                        color="red"
                                        class="mt-n1"
                                        dark
                                        x-small
                                        outlined
                                        fab
                                        @click="removePriceToUser(item)"
                                        v-if="item.extraCharge !== null"
                                >
                                    <v-icon dark>
                                        mdi-close
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-select>
                    </div>
            </template>
        </v-data-table>
        <v-dialog
                :close-delay="3000"
                v-model="snackbar.show"
                max-width="360"
                overlay-opacity="0.3"
        >
            <v-card>
                <div class="pa-4 pb-0">
                    <div class="subtitle-1 text-center" v-text="snackbar.message"></div>
                </div>
                <v-card-actions>
                    <v-btn
                            small
                            class="mx-auto"
                            color="primary"
                            @click="snackbar.show = false"
                    >
                        {{$t('closeLabel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: ['prices'],
        name: "PricingUsers",
        data() {
            return {
                snackbar: {
                    show: false,
                    message: "",
                },
                users: {
                    headers: [
                        {
                            text: this.$t('usersNameLabel'),
                            value: 'userFullName',
                        },
                        {
                            text: this.$t('usersPersonalNoLabel'),
                            value: 'personalNo',
                        },
                        {
                            text: this.$t('usersEmailLabel'),
                            value: 'email',
                        },
                        {
                            text: "",
                            sortable: false,
                            value: "actions",
                            align: "end",
                        },
                    ],
                    values: [],
                },
            }
        },
        methods: {
            getOwnUsers() {
                this.axios.get("api/extra-charge/own-users")
                    .then((response) => {
                        this.users.values = response.data;
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            setPricingToUser(item) {
                let params = {
                    "UserID": item.id,
                    "ChargeID": item.extraCharge.id
                }
                this.axios.post("api/extra-charge/assigne", params)
                    .then(() => {
                        this.snackbar.message = this.$t("pricingChangedLabel")
                        this.snackbar.show = true;
                    })
                    .catch(() => {
                        this.snackbar.message = this.$t("priceErrorLabel")
                        this.snackbar.show = true;
                    })
            },
            removePriceToUser(item) {
                this.axios.delete("api/extra-charge/remove-charge", {
                    params: {
                        userId: item.id,
                    },
                })
                .then(() => {
                    let user = this.users.values.find(x => x.id === item.id);
                    user.extraCharge = null;
                })
                .catch((error) => {
                    console.log(error)
                })
            }
        },
        mounted() {
            this.getOwnUsers();
        },
    }
</script>

<style scoped>

</style>